const YMD_PATTERN = /^\d{4}-\d{2}-\d{2}$/

/**
 * Validate optional From/To date fields for the Negative Sales report.
 * @returns {string|null} Error message, or null when the range is usable.
 */
export function getDateRangeError(from, to) {
  const fromTrimmed = String(from || '').trim()
  const toTrimmed = String(to || '').trim()

  if (fromTrimmed && !YMD_PATTERN.test(fromTrimmed)) {
    return 'From date must be a valid date (YYYY-MM-DD).'
  }
  if (toTrimmed && !YMD_PATTERN.test(toTrimmed)) {
    return 'To date must be a valid date (YYYY-MM-DD).'
  }
  if (fromTrimmed && toTrimmed && fromTrimmed > toTrimmed) {
    return 'From date must not be greater than To date.'
  }
  return null
}
